import { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/system';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { theme, loadMedia } from '../../lib/index';

function CardCertificate({ certficate }) {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState({
    id: '',
    src: '',
    alt: '',
  });

  useEffect(() => {
    if (certficate?.reader_profile_certificates_image) {
      loadMedia(certficate?.reader_profile_certificates_image).then(setImage);
    }
  }, [certficate]);

  const handleClickOpen = () => {
    setOpen(!open);
  };

  // Styling
  const Card = styled(Box, {})({
    width: open ? '100%' : '45%',
    flexGrow: open ? 1 : 0,
    order: open ? 'unset' : 1,

    borderRadius: ' 10px',
    background: `${theme.palette.backgroundgrey}aa`,
    boxShadow: `0 0 0 ${theme.palette.midgrey}`,

    transition: 'box-shadow 250ms ease-in-out, transform 250ms ease-in-out, width 250ms ease-in-out',

    '&:hover': {
      boxShadow: `3px 3px 10px ${theme.palette.midgrey}`,

      transform: 'scale(1.01)',

      transition: 'box-shadow 250ms ease-in-out, transform 250ms ease-in-out',
    },

    [theme.breakpoints.up('laptop')]: {
      width: open ? '100%' : '31%',
    },
  });

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      ...theme.typography.p,

      padding: 20,
      maxWidth: 500,

      background: theme.palette.backgroundgrey,
      boxShadow: '3px 3px 10px black',

      whiteSpace: 'pre-wrap',
      color: theme.palette.fontgrey,
      fontSize: 16,
      lineHeigt: '28px',
    },
  }));

  const Despcription = styled(Typography, {})({
    ...theme.typography.p16,

    display: open ? 'block' : 'none',
    overflow: 'hidden',
    height: open ? 'fit-content' : 120,

    whiteSpace: 'pre-wrap',
    textOverflow: 'ellipsis',
    WebkitLineClamp: '5',
    WebkitBoxOrient: 'vertical',

    [theme.breakpoints.up('laptop')]: {
      display: '-webkit-box',
    },
  });

  const TextBox = styled(Box, {})({
    padding: '0 20px 20px',

    '& .card-headline': {
      ...theme.typography.pBold17,

      wordBreak: 'break-word',
    },
  });

  const StyledButton = styled(Button, {})({
    margin: '0 0 20px',
    padding: 0,
    width: '100%',
    height: 'auto',

    boxShadow: `0 0 20px ${theme.palette.midgrey}`,

    '& img': {
      width: '100%',
    },
  });

  return (
    <Card>
      <Box>
        <StyledButton onClick={handleClickOpen}>
          <img alt={image.alt} src={image.src} />
        </StyledButton>
      </Box>
      <TextBox>
        <Typography sx={{ marginBottom: '10px' }} className="card-headline">
          {certficate.reader_profile_certificates_name}
        </Typography>
        {
          certficate.reader_profile_certificates_description.length > 200
          && !open
            ? (
              <CustomTooltip
                arrow
                title={certficate.reader_profile_certificates_description}
              >
                <Despcription>
                  {certficate.reader_profile_certificates_description}
                </Despcription>
              </CustomTooltip>
            )
            : (
              <Despcription>
                {certficate.reader_profile_certificates_description}
              </Despcription>
            )
        }
      </TextBox>
    </Card>
  );
}

export default CardCertificate;
